import React, {useEffect, useRef} from "react";
import styles from "./MarcheFrancais.module.scss"
import Image from "./Global/Image";
import TitleBloc from "./Elements/TitleBloc";

import gsap from "gsap";
import ScrollMagic from "scrollmagic";
import {TimelineMax} from "gsap";

import playstationSrc from "../images/playstation.jpg";
import playstationSrcRet from "../images/playstation@2x.jpg";
import playstationWebp from "../images/playstation.webp";
import playstationWebpRet from "../images/playstation@2x.webp";
import playstationMobile from "../images/mobile/playstation.webp";
import isMobile from "ismobilejs";
import {Helmet} from "react-helmet";

//Tables images 1

export default function MarcheFrancais() {
    const parent = useRef(null);
    const podiumRef = useRef(null);
    const ad_container = useRef(null);

    const stepSizeFn = () => {
        const steps = document.getElementsByClassName(styles.Step);

        Object.values(steps).map((step, index) => {
            const rank = step.dataset.rank;

            const height = 150 - (40 * (rank - 1));
            gsap.set(step, {
                height: `${height * 100 / (isMobile().phone ? 414 : 1440)}vw`
            })
        });
    };


    useEffect(() => {
        stepSizeFn();

        if (isMobile().phone) {
            const tables = document.getElementsByClassName(styles.Table);
            const offsetLeft = tables[0].getBoundingClientRect().left;

            gsap.set(tables, {
                marginLeft: -(offsetLeft),
                //marginRight: offsetLeft
            })
        }

        const controller = new ScrollMagic.Controller({
            refreshIntervals: 0
        });

        const tableElements = parent.current.querySelectorAll('[data-scroll-animation]');
        Object.values(tableElements).map(item => {
            new ScrollMagic.Scene({
                triggerHook: 'onEnter', triggerElement: item, duration: '50%', reverse: true
            })
                .setTween(
                    new TimelineMax().to(item, .3, {
                        x: 0,
                        y: 0,
                        opacity: 1
                    }, 'start'))
                .addTo(controller);
        });

        window.addEventListener('scroll', () => {
            const podiumRect = podiumRef.current.getBoundingClientRect();

            if (podiumRect.bottom <= window.innerHeight) {
                const steps = document.getElementsByClassName(styles.PodiumStep);

                Object.values(steps).map((step, index) => {
                    const stepElement = step.getElementsByClassName(styles.Step)[0];

                    gsap.to(stepElement, 1, {
                        scaleY: 1,
                        onComplete: () => {
                            gsap.to([stepElement.querySelector('span'), step.querySelectorAll('figure,span,strong')], .3, {
                                opacity: 1,
                                y: 0
                            })
                        }
                    })
                })
            }
        });

        window.onresize = () => {
            stepSizeFn();
        }
    }, []);

    const svg = `
<svg width="1067px" height="203px" viewBox="0 0 1067 203" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(2.000000, -1.000000)">
            <g transform="translate(0.000000, 52.000000)">
                <rect stroke="#74B743" stroke-width="3" x="0" y="0" width="67" height="131" rx="8"></rect>
                <path d="M8,4 L16.6825256,4 C17.7870951,4 18.6825256,4.8954305 18.6825256,6 L18.6825256,9.65473938 C18.6825256,11.3115936 20.0256714,12.6547394 21.6825256,12.6547394 L45.3023529,12.6547394 C46.9592072,12.6547394 48.3023529,11.3115936 48.3023529,9.65473938 L48.3023529,6 C48.3023529,4.8954305 49.1977834,4 50.3023529,4 L59,4 C61.209139,4 63,5.790861 63,8 L63,123 C63,125.209139 61.209139,127 59,127 L8,127 C5.790861,127 4,125.209139 4,123 L4,8 C4,5.790861 5.790861,4 8,4 Z" fill="#B8E986"></path>
                <path d="M24,8 L37,8" stroke="#74B743" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M42,8 L43,8" stroke="#74B743" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
            <g transform="translate(106.000000, 17.000000)">
                <text font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="26" font-weight="bold" line-spacing="40">
                    <tspan x="6" y="172" fill="#74B743">+16%</tspan>
                    <tspan x="70.532" y="172" fill="#010020">&nbsp;vs&nbsp;</tspan>
                    <tspan x="109.142" y="172" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-weight="normal" fill="#010020">2019</tspan>
                </text>
                <text font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="30" font-weight="normal" line-spacing="30" fill="#010020">
                    <tspan x="6" y="114">Millions d’euros</tspan>
                </text>
                <text font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="70" font-weight="600" line-spacing="100" fill="#010020">
                    <tspan x="0" y="53">1426</tspan>
                </text>
            </g>
            <text font-family="DINNextLTPro-Light, DIN Next LT Pro" font-size="24" font-weight="300" line-spacing="24" fill="#010020">
                <tspan x="0" y="20">Software</tspan>
            </text>
            <path d="M265.389075,100.583197 L464.389042,100.697697" stroke="#000000" transform="translate(364.514649, 100.625582) rotate(89.967034) translate(-364.514649, -100.625582) "></path>
            <g transform="translate(415.000000, 0.000000)">
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="20" fill="#010020">
                    <tspan x="0" y="16">Marché des apps</tspan>
                    <tspan x="0" y="36">en france 2020</tspan>
                    <tspan x="0" y="56" font-family="Helvetica" font-weight="normal">iOS et Google Play</tspan>
                    <tspan x="0" y="76" font-family="Helvetica" font-weight="normal">combinés</tspan>
                </text>
                <g transform="translate(86.000000, 20.000000)">
                    <text font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="15.958" y="122.518" fill="#74B743">43%</tspan>
                        <tspan x="63.214" y="125" font-size="20" fill="#74B743"></tspan>
                        <tspan x="25.6577148" y="143" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Jeux</tspan>
                    </text>
                    <text font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="224.458" y="158.518" fill="#B8E986">57%</tspan>
                        <tspan x="271.714" y="161" font-size="20" fill="#B8E986"></tspan>
                        <tspan x="209.559326" y="179" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Applications</tspan>
                    </text>
                    <g transform="translate(77.000000, 0.000000)" fill-rule="nonzero">
                        <path d="M42.5494033,152 L42.4340054,151.942477 C9.83571403,134.306954 -6.61222978,96.87449 2.48616184,61.0286064 C11.5845535,25.1827228 43.9114849,0.055081307 81,0 L81,23.0093854 C54.4433202,22.9922325 31.264667,40.9522892 24.7263368,66.613221 C18.1880066,92.2741529 29.9591108,119.085212 53.3044922,131.705722 L53.4660493,131.786255 L42.5494033,152 Z" fill="#74B743"></path>
                        <path d="M80.6475706,162 L78.531528,162 C66.5054811,161.713967 54.6998084,158.688039 44,153.149178 L54.4200802,132.635555 C62.0826185,136.585062 70.5328758,138.736246 79.1377456,138.927936 L80.6590087,138.927936 C111.833481,138.900797 137.312773,113.857589 138.112425,82.4578502 C138.112425,81.9392474 138.112425,81.432169 138.112425,80.9135662 C138.085822,49.5249536 113.254259,23.8669682 82.1116434,23.0490147 L81.9286343,23.0490147 L82.4090331,0 L82.7292991,0 C126.27313,1.14919043 160.983941,37.0371474 161,80.9250907 C161,81.6396102 161,82.3426051 161,83.0571246 C159.865627,126.942803 124.241725,161.931309 80.6704468,161.953902 L80.6475706,162 Z" fill="#B8E986"></path>
                    </g>
                    <text font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="12" font-weight="bold" line-spacing="15" fill="#010020">
                        <tspan x="146.262" y="68">PAR</tspan>
                        <tspan x="106.674" y="83">TÉLÉCHARGEMENT</tspan>
                    </text>
                </g>
                <g transform="translate(360.000000, 2.000000)">
                    <text font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="15.958" y="14.518" fill="#74B743">67%</tspan>
                        <tspan x="63.214" y="17" font-size="20" fill="#74B743"></tspan>
                        <tspan x="25.6577148" y="35" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Jeux</tspan>
                    </text>
                    <text font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="224.458" y="138.518" fill="#B8E986">33%</tspan>
                        <tspan x="271.714" y="141" font-size="20" fill="#B8E986"></tspan>
                        <tspan x="209.559326" y="159" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Applications</tspan>
                    </text>
                    <g transform="translate(41.000000, 18.000000)" fill-rule="nonzero">
                        <path d="M80.6463822,161.999858 C36.1889278,162.082607 0.0823756155,125.884784 0.000140711287,81.1497583 C-0.0820941929,36.4147327 35.8911289,0.08274834 80.3485832,0 L80.4402137,23.0506344 C54.1052373,23.1479746 31.1909595,41.2084002 24.7893759,66.9131479 C18.3877922,92.6178957 30.1300276,119.41739 53.3071954,131.99983 C76.4843632,144.582269 105.190916,139.741646 123.025461,120.243634 L123.128545,120.128381 L140,135.71061 L139.885462,135.837388 C124.626294,152.485563 103.153585,161.968815 80.6463822,161.999858 Z" fill="#74B743"></path>
                        <path d="M141.130026,134 L123.990888,118.847975 C132.8067,108.696517 137.822049,95.7660554 138.170668,82.2899794 C138.170668,81.7841455 138.170668,81.2668154 138.170668,80.7609815 C138.156141,49.4190695 113.32328,23.7964053 82.1828175,22.9924502 L82,22.9924502 L82.4798959,0 L82.7998264,0 C126.301768,1.15237206 160.977929,36.9538713 161,80.737989 C161,81.4392588 161,82.1520247 161,82.8647907 C160.504682,101.719391 153.476218,119.807083 141.130026,134 L141.130026,134 Z" fill="#B8E986"></path>
                    </g>
                    <text font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="12" font-weight="bold" line-spacing="15" fill="#010020">
                        <tspan x="110.262" y="78">PAR</tspan>
                        <tspan x="92.2380469" y="93">D</tspan>
                        <tspan x="99.7980469" y="93" font-family="Helvetica-Bold, Helvetica">É</tspan>
                        <tspan x="107.801953" y="93">PENSES</tspan>
                        <tspan x="72.078" y="108">CONSOMMATEURS</tspan>
                    </text>
                </g>
            </g>
        </g>
    </g>
</svg>`;

    const svgMobile = `
<svg width="346px" height="626px" viewBox="0 0 346 626" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-19" transform="translate(-18.000000, -6.000000)">
            <g id="Group-16" transform="translate(0.000000, 268.000000)">
                <text id="Marché-des-apps-en-f" font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" line-spacing="20" fill="#010020">
                    <tspan x="18" y="16">Marché des apps</tspan>
                    <tspan x="18" y="36">en france 2020</tspan>
                    <tspan x="18" y="56" font-family="Helvetica" font-weight="normal">iOS et Google Play</tspan>
                    <tspan x="18" y="76" font-family="Helvetica" font-weight="normal">combinés</tspan>
                </text>
                <g id="Group-13" transform="translate(0.000000, 195.000000)">
                    <text id="43%-Jeux" font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="15.958" y="14.518" fill="#74B743">43%</tspan>
                        <tspan x="63.214" y="17" font-size="20" fill="#74B743"></tspan>
                        <tspan x="25.6577148" y="35" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Jeux</tspan>
                    </text>
                    <text id="43%-Applications" font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="214.458" y="143.518" fill="#B8E986">57%</tspan>
                        <tspan x="261.714" y="146" font-size="20" fill="#B8E986"></tspan>
                        <tspan x="199.559326" y="164" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Applications</tspan>
                    </text>
                    <g id="Cercle-mobile-1" transform="translate(57.000000, 5.000000)" fill-rule="nonzero">
                        <path d="M42.5494033,152 L42.4340054,151.942477 C9.83571403,134.306954 -6.61222978,96.87449 2.48616184,61.0286064 C11.5845535,25.1827228 43.9114849,0.055081307 81,0 L81,23.0093854 C54.4433202,22.9922325 31.264667,40.9522892 24.7263368,66.613221 C18.1880066,92.2741529 29.9591108,119.085212 53.3044922,131.705722 L53.4660493,131.786255 L42.5494033,152 Z" id="Path" fill="#74B743"></path>
                        <path d="M80.6475706,162 L78.531528,162 C66.5054811,161.713967 54.6998084,158.688039 44,153.149178 L54.4200802,132.635555 C62.0826185,136.585062 70.5328758,138.736246 79.1377456,138.927936 L80.6590087,138.927936 C111.833481,138.900797 137.312773,113.857589 138.112425,82.4578502 C138.112425,81.9392474 138.112425,81.432169 138.112425,80.9135662 C138.085822,49.5249536 113.254259,23.8669682 82.1116434,23.0490147 L81.9286343,23.0490147 L82.4090331,0 L82.7292991,0 C126.27313,1.14919043 160.983941,37.0371474 161,80.9250907 C161,81.6396102 161,82.3426051 161,83.0571246 C159.865627,126.942803 124.241725,161.931309 80.6704468,161.953902 L80.6475706,162 Z" id="Path" fill="#B8E986"></path>
                    </g>
                    <text id="Par-téléchargement" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="12" font-weight="bold" line-spacing="15" fill="#010020">
                        <tspan x="126.262" y="73">PAR</tspan>
                        <tspan x="86.674" y="88">TÉLÉCHARGEMENT</tspan>
                    </text>
                </g>
                <g id="Group-12" transform="translate(97.000000, 4.000000)">
                    <text id="67%-Jeux" font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="15.958" y="109.518" fill="#74B743">67%</tspan>
                        <tspan x="63.214" y="112" font-size="20" fill="#74B743"></tspan>
                        <tspan x="25.6577148" y="130" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Jeux</tspan>
                    </text>
                    <text id="33%-Applications" font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="22" font-weight="600" line-spacing="18">
                        <tspan x="193.458" y="14.518" fill="#B8E986">33%</tspan>
                        <tspan x="240.714" y="17" font-size="20" fill="#B8E986"></tspan>
                        <tspan x="178.559326" y="35" font-family="Helvetica" font-size="15" font-weight="normal" fill="#000000">Applications</tspan>
                    </text>
                    <g id="Cercle-mobile-2" transform="translate(73.000000, 50.000000)" fill-rule="nonzero">
                        <path d="M80.6463822,161.999858 C36.1889278,162.082607 0.0823756155,125.884784 0.000140711287,81.1497583 C-0.0820941929,36.4147327 35.8911289,0.08274834 80.3485832,0 L80.4402137,23.0506344 C54.1052373,23.1479746 31.1909595,41.2084002 24.7893759,66.9131479 C18.3877922,92.6178957 30.1300276,119.41739 53.3071954,131.99983 C76.4843632,144.582269 105.190916,139.741646 123.025461,120.243634 L123.128545,120.128381 L140,135.71061 L139.885462,135.837388 C124.626294,152.485563 103.153585,161.968815 80.6463822,161.999858 Z" id="Path" fill="#74B743"></path>
                        <path d="M141.130026,134 L123.990888,118.847975 C132.8067,108.696517 137.822049,95.7660554 138.170668,82.2899794 C138.170668,81.7841455 138.170668,81.2668154 138.170668,80.7609815 C138.156141,49.4190695 113.32328,23.7964053 82.1828175,22.9924502 L82,22.9924502 L82.4798959,0 L82.7998264,0 C126.301768,1.15237206 160.977929,36.9538713 161,80.737989 C161,81.4392588 161,82.1520247 161,82.8647907 C160.504682,101.719391 153.476218,119.807083 141.130026,134 L141.130026,134 Z" id="Path" fill="#B8E986"></path>
                    </g>
                    <text id="PAR-DÉPENSES-CONSOM" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="12" font-weight="bold" line-spacing="15" fill="#010020">
                        <tspan x="142.262" y="110">PAR</tspan>
                        <tspan x="124.238047" y="125">D</tspan>
                        <tspan x="131.798047" y="125" font-family="Helvetica-Bold, Helvetica">É</tspan>
                        <tspan x="139.801953" y="125">PENSES</tspan>
                        <tspan x="104.078" y="140">CONSOMMATEURS</tspan>
                    </text>
                </g>
            </g>
            <path d="M19.499747,233.489356 L363.49969,233.687284" id="Path-5" stroke="#000000" transform="translate(190.999970, 233.098964) rotate(-0.032966) translate(-190.999970, -233.098964) "></path>
            <g id="Group-17" transform="translate(127.000000, 15.000000)">
                <text id="+16%-vs-2019" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="26" font-weight="bold" line-spacing="40">
                    <tspan x="6" y="172" fill="#74B743">+16%</tspan>
                    <tspan x="70.532" y="172" fill="#010020"> vs </tspan>
                    <tspan x="109.142" y="172" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-weight="normal" fill="#010020">2019</tspan>
                </text>
                <text id="Millions-d’euros" font-family="DINNextLTPro-Regular, DIN Next LT Pro" font-size="30" font-weight="normal" line-spacing="30" fill="#010020">
                    <tspan x="6" y="114">Millions d’euros</tspan>
                </text>
                <text id="1426" font-family="DINNextLTPro-Heavy, DIN Next LT Pro" font-size="70" font-weight="600" line-spacing="100" fill="#010020">
                    <tspan x="0" y="53">1426</tspan>
                </text>
            </g>
            <g id="Mobile" transform="translate(21.000000, 50.000000)">
                <rect id="Rectangle" stroke="#74B743" stroke-width="3" x="0" y="0" width="67" height="131" rx="8"></rect>
                <path d="M8,4 L16.6825256,4 C17.7870951,4 18.6825256,4.8954305 18.6825256,6 L18.6825256,9.65473938 C18.6825256,11.3115936 20.0256714,12.6547394 21.6825256,12.6547394 L45.3023529,12.6547394 C46.9592072,12.6547394 48.3023529,11.3115936 48.3023529,9.65473938 L48.3023529,6 C48.3023529,4.8954305 49.1977834,4 50.3023529,4 L59,4 C61.209139,4 63,5.790861 63,8 L63,123 C63,125.209139 61.209139,127 59,127 L8,127 C5.790861,127 4,125.209139 4,123 L4,8 C4,5.790861 5.790861,4 8,4 Z" id="Rectangle" fill="#B8E986"></path>
                <path d="M24,8 L37,8" id="Line" stroke="#74B743" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M42,8 L43,8" id="Line" stroke="#74B743" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
            <text id="Software" font-family="DINNextLTPro-Light, DIN Next LT Pro" font-size="24" font-weight="300" line-spacing="24" fill="#010020">
                <tspan x="21" y="18">Software</tspan>
            </text>
        </g>
    </g>
</svg>`;

    const tableArray = [
        {
            title: "gratuites",
            games: {
                "brain-out": {
                    title: "Brain Out",
                    editor: "Eyewind"
                },
                "coin-master": {
                    title: "Coin Master",
                    editor: "Moon Active"
                },
                "gardenscapes": {
                    title: "Gardenscapes New Acres",
                    editor: "Playrix"
                },
                "among-us": {
                    title: "Among Us!",
                    editor: "InnerSloth"
                },
                "brawl-stars": {
                    title: "Brawl Stars",
                    editor: "Supercell"
                },
                "brain-test": {
                    title: "Brain Test: Tricky Puzzles",
                    editor: "Unico Studio"
                },
                "magic-tiles": {
                    title: "Magic Tiles 3",
                    editor: "Amanotes"
                },
                "homescapes": {
                    title: "Homescapes",
                    editor: "Playrix"
                },
                "scrabble-go": {
                    title: "Scrabble Go",
                    editor: "Scopely"
                },
                "fishdom": {
                    title: "Fishdom: Deep Dive",
                    editor: "Playrix"
                },
            }
        },
        {
            title: "payantes",
            games: {
                "minecraft": {
                    title: "Minecraft Pocket Edition",
                    editor: "Microsoft"
                },
                "monopoly": {
                    title: "Monopoly by Marmalade",
                    editor: "Marmalade"
                },
                "plague": {
                    title: "Plague Inc",
                    editor: "Ndernic Creations"
                },
                "football-manager": {
                    title: "Football Manager 2020 Mobile",
                    editor: "SEGA SAMMY"
                },
                "gta": {
                    title: "Gran Theft Auto : San Andreas",
                    editor: "Take-Two Interactive"
                },
                "farming-simulator": {
                    title: "Farming Simulator 20",
                    editor: "Giant Software"
                },
                "geometry-dash": {
                    title: "Geometry Dash",
                    editor: "RobTop"
                },
                "clue": {
                    title: "Clue: The Classic Mystery Game",
                    editor: "Marmalade"
                },
                "true-skate": {
                    title: "True Skate",
                    editor: "True Axis"
                },
                "mini-metro": {
                    title: "Mini Metro",
                    editor: "Playdigious"
                },
            }
        }
    ];

    const podium = {
        "clash-of-clans": {
            title: "Clash of clans",
            editor: "Supercell",
            rank: 2
        },
        "coin-master": {
            title: "Coin Master",
            editor: "Moon Active",
            rank: 1
        },
        "brawl-stars": {
            title: "Brawl Stars",
            editor: "Supercell",
            rank: 3
        },
    };

    useEffect(() => {
       const ad = document.querySelector('.dcmads iframe');
        gsap.set('.dcmads', {
            display: 'none'
        });

        if (ad) {
            ad_container.current.innerHTML = ad.outerHTML;
        }


    }, []);

    return (
        <section className={styles.Main}>
            <div className="container">
                <div ref={ad_container} style={{
                    width: isMobile().phone ? 300 : 920,
                    height: 250,
                    margin: '0 auto 100px'
                }}/>

                <p className={'head-text'}>
                    Le marché français <strong>du jeu mobile</strong>
                </p>


                <h2 className={styles.Subtitle}>
                    ÉVOLUTION DU CHIFFRE D’AFFAIRES 2020
                </h2>

                <div className={styles.Illustration} dangerouslySetInnerHTML={{__html: isMobile().phone ? svgMobile : svg}}/>


                <h2 className={styles.Subtitle}>
                    classements des téléchargements
                </h2>

                <div className={styles.Tables} ref={parent}>
                    {
                        Object.values(tableArray).map((table, index) => {
                            return (
                                <table className={styles.Table} key={index}>
                                    <thead>
                                    <tr data-scroll-animation>
                                        <th colSpan={4}>
                                            Applications <strong>{table.title}</strong>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        Object.keys(table.games).map((key, index) => {
                                            const arr = table.games[key];

                                            let image = {
                                                src: require(`../images/games/${key}.jpg`).default,
                                                srcRet: require(`../images/games/${key}@2x.jpg`).default,
                                                webp: require(`../images/games/${key}.webp`).default,
                                                webpRet: require(`../images/games/${key}@2x.webp`).default
                                            };

                                            return (
                                                <tr key={index} data-scroll-animation>
                                                    <td>
                                                        <strong>
                                                            {index + 1}
                                                        </strong>
                                                    </td>
                                                    <td>{arr.title}</td>
                                                    <td>
                                                        <strong>
                                                            {arr.editor}
                                                        </strong>
                                                    </td>
                                                    <td align={'right'}>
                                                        <Image {...image}/>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            )
                        })
                    }
                </div>

                <div className={styles.PodiumWrapper}>
                    <h2 className={styles.Subtitle}>
                        Dépenses des joueurs
                    </h2>

                    <ul className={styles.Podium} ref={podiumRef}>
                        {
                            Object.keys(podium).map((key, index) => {
                                const image = {
                                    src: require(`../images/games/${key}.jpg`).default,
                                    srcRet: require(`../images/games/${key}@2x.jpg`).default,
                                    webp: require(`../images/games/${key}.webp`).default,
                                    webpRet: require(`../images/games/${key}@2x.webp`).default
                                };



                                return (
                                    <li className={styles.PodiumStep} key={key}>
                                        <Image {...image}/>

                                        <span>
                                        { podium[key].title }
                                    </span>

                                        <strong>
                                            { podium[key].editor }
                                        </strong>

                                        <div className={styles.Step} data-rank={podium[key].rank}>
                                            <span>{podium[key].rank}</span>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>

            <TitleBloc number={2} image={{
                src: playstationSrc,
                srcRet: playstationSrcRet,
                webp: playstationWebp,
                webpRet: playstationWebpRet,
                mobile: playstationMobile
            }}>
                <h2>
                    Les éditeurs <br/>
                    à couteaux tirés
                </h2>

                <p>
                    Plusieurs grandes familles d'entreprises se partagent le marché : les fabricants d'appareils (consoles, ordinateurs, smartphones), les développeurs et éditeurs, les réseaux de distribution physiques ou en ligne, les équipementiers et les plateformes de diffusion (streaming). Pour les consoles, alors que le marché avait été un temps dominé par Nintendo et Sego, ce sont Sony (Playstation), Microsoft (Xbox) et Nintendo (Wii, Switch…) qui règnent désormais en maîtres et se partagent l'oligopole depuis plusieurs décennies.
                </p>
            </TitleBloc>
        </section>
    )
}
